module.exports = __webpack_public_path__ + "static/img/huaishuImg4.677adb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuImg4.png
// module id = LZ1a
// module chunks = 0